/* v4.1.4 修改：

*/

import { Component } from '@theme/component';
import { fetchConfig } from '@theme/utilities';
import { cartPerformance } from '@theme/performance';

!function () {
  "use strict";

  //Remove sp
class SpRemoveBtn extends HTMLElement {
  constructor() {
    super();
  }
}
if (!customElements.get('sp-remove')) {
 customElements.define('sp-remove', SpRemoveBtn);
}

if (!customElements.get('sp-box')) {
  customElements.define(
    'sp-box',
class SpBox extends Component{ //HTMLElement {
      constructor() {
        super();
        this.jmin = 7*14;
        this.ph = 'ship'+'ping'+'-prote'+'ction';
        this.percentage = 0.021;
        this.cartCount=0;
      }
    
#uplist()
{
  const sectionId = document.querySelector('cart-items-component')?.dataset.sectionId;
    if (!sectionId) return;
const url = `${window.location.pathname}?section_id=${sectionId}`;
fetch(url, { credentials: 'same-origin' })
    .then(function(response) {
      return response.text();
    })
    .then(function(html) {
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(html, 'text/html');
      const newSection = newDoc.querySelector('#shopify-section-' + sectionId);
      const currentSection = document.querySelector('#shopify-section-' + sectionId);
      if (newSection && currentSection) {
        currentSection.innerHTML = newSection.innerHTML;
      }
    })
    .catch(function(error) {
      console.error('update box failed:', error);
    });
}

      onSpRemove(){        
        this.querySelector('.loading_spinner').classList.remove('hidden'); 
        this.querySelector('#b-protection-r').classList.add('hidden');     
        fetch('/cart.js').then((response) => response.json())  
        .then((cart) => {
          const cartItemsComponents = document.querySelectorAll('cart-items-component');
             if (cart.status) {
              this.handleErrorMessage(response.description);
            } else if (!cartItemsComponents) {
              window.location = Theme.routes.cart_url;
              return;
            }
            this.cartCount=cart.item_count;
          const s = cart.items.filter(item => item.handle === this.ph) ?? false;
          if (s){
            s.forEach((v) => {this.removeItem(v.id);this.cartCount--});
          }
         let itemIds = [];
          cartItemsComponents.forEach((i) => {
         if (i instanceof HTMLElement && i.dataset.sectionId) {
           itemIds.push(i.dataset.sectionId);
         }
        });
        const body = JSON.stringify({sections: Array.from(itemIds).join(','),});
       fetch('/cart.js', fetchConfig('json', { body })).then((r) => r.json()).then((cart)=>{this.#uplist();});

        })
        .finally(()=>{  
        this.querySelector('.loading_spinner').classList.add('hidden');
        })       
      }

    getCart(){ 
      fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
          const cItems = cart.items.filter(item => item.handle != this.ph)??[];
          const oldSp = cart.items.find(item => item.handle === this.ph) ?? false;
          if (cItems.length > 0) {
            this.cartCount=cart.item_count;
            const m=cart.total_price;
            let i=0;
            if (oldSp){ 
              if(cart.total_price>200000) {this.outTotal(oldSp.id);                
              } else{
                i=oldSp.final_line_price;this.upCart(oldSp,m-i); }              
           }
           else
           {
            this.upCart(oldSp,m);
           }
          }
          else{ //无
            this.clearCart();
          }
        })
        .catch((e) => console.error('Error updating cart:', e));
    }  
      
    //当item变更时
    upCart(f,m){ 
      const newP = parseFloat(m) * this.percentage;
      const newPrice = (newP< this.jmin) ? this.jmin : newP;      
      this.querySelector('.loading_spinner').classList.remove('hidden'); 
      this.getVariant().then((d) => {
        const v = this.getNewVariant(d,newPrice);  
        if(v!=0){      
          if (f){
              if (f.id != v.id) {
                this.removeItem(f.id).finally(() =>{this.cartCount--;this.addItem(v.id);});
              } else if(f.quantity>1) {
                this.updateItemPrice(v.id);
              }             
          } else if(this.querySelector('#b-protection-i').checked){
              this.addItem(v.id); 
          }
        } 
      })
      .finally(() =>{
        this.querySelector('.loading_spinner').classList.add('hidden');
          /*
            this.submitButton.classList.remove('hidden');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');            
            cartPerformance.measureFromEvent("add:user-action", evt);*/
        }); 
    }

      // 清空
      clearCart()
      {        
        fetch('/cart/clear.js', {
          method: 'POST',
          headers: {
          'Content-Type': 'application/json',
          }
        })
        .then((response) => response.json())
        .then((d) => {
              //window.location.reload();
          });
      }

      //变体
      getVariant() {
        return fetch(`/products/${this.ph}.js`)
        .then((response) => response.json()
       );
      }

      getNewVariant(p, x) {
        // 没变体返回0
        if (!p.variants || p.variants.length === 0) return 0;
        let newV = p.variants[0];
        let minDifference = Math.abs(parseFloat(newV.price) - x);
        for (const v of p.variants) {
          const difference = Math.abs(parseFloat(v.price) - x);
          if (difference < minDifference) {
            newV = v;
            minDifference = difference;
          }
        }
        return newV;
      }

      addItem(id) {
        const cart = document.querySelectorAll('cart-items-component');
        let ids = [];
        cart.forEach((i) => {
         if (i instanceof HTMLElement && i.dataset.sectionId) {
           ids.push(i.dataset.sectionId);
         }
        });
      
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {'Content-Type': 'application/json',},
              body: JSON.stringify({
                id: id,
                quantity: 1,
                sections: Array.from(ids).join(','),
              }),
            }) 
            .then((response) => response.json())
            .then((d) => { 
            /*  
        this.dispatchEvent(
          new CartUpdateEvent({},'b-protection-i', {           
            itemCount:this.cartCount+1,
            source:'cart-items-component',
            sections:d.sections,
          })
        );  */       

            this.#uplist();

              })
           .catch((error) => console.error("add Error:", error));
           
      }
      
      removeItem(oid) {
        if (oid > 0) {
         return fetch(`/cart/change.js?id=${oid}&quantity=0`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            }
          })
          .then((response) => response.json())
          .catch((error) => console.error("removing Error:", error));
        }
      }

      outTotal(id){
          let t='Sorry, you cannot purchase Shipping Protection for this order as the total amount exceeds the limit of 2000.';
          this.removeItem(id);
      }

      updateItemPrice(vId) {
        if (vId > 0) {
          fetch(`/cart/change.js?id=${vId}&quantity=1`, {
            method: "POST",
            headers: { "Content-Type": "application/json", },
            /*body:JSON.stringify({
              id: vId,
              quantity: 1,
            }),  */
          });
        }
      }
    })
}

class SpForm extends Component{ // HTMLElement {
   constructor() {
    super();
        //this.form = this.querySelector('form');
        this.hideErrors = this.dataset.hideErrors === 'true';        
  }
   connectedCallback(){  this.submitButton = this.querySelector('#b-protection-i');  
    this.submitButton.addEventListener('change', this.onSubmitHandler.bind(this));
  }  
      onSubmitHandler(evt) {
        evt.preventDefault(); 
        if (!this.submitButton.checked) return;       
        //this.submitButton.prop('checked', true);
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('hidden');
        this.querySelector('.loading_spinner').classList.remove('hidden');   

        //添加前删除
        document.querySelector('sp-box').getCart();
        /*
       .finally(() => {
            this.submitButton.classList.remove('hidden');
             if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading_spinner').classList.add('hidden');
            cartPerformance.measureFromEvent("add:user-action", evt);
          }); */


      }
      

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.sp-form_error-msg-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.sp-form_error-msg');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
}
if (!customElements.get('sp-form')) {
  customElements.define('sp-form',SpForm);
}

}();